import AdminListPage from "./components/AdminListPage";
export default function HartaList() { return <AdminListPage title="Senarai Harta" endpoint="/admin/harta" />; }
